module.exports = __webpack_public_path__ + "img/2.1641520899224.png";